export default __webpack_public_path__ + "static/media/300.7062e36f.png";